import { render, staticRenderFns } from "./PageSearchUser.vue?vue&type=template&id=7d4fa8ce&"
import script from "./PageSearchUser.vue?vue&type=script&lang=ts&"
export * from "./PageSearchUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports